<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="other_patients"
      endpoint="/otherpatients"
      action-path="/treatment"
      action-label="Treatment"
      no-permission-text="You have no permission to View Other Service Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Other Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Other Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Other Patients", active: true }],
    };
  },
};
</script>
